import React from 'react';
import '../../app/styles/spinner.css';

export default function LoadingSpinner({ width = 24, strokeWidth = 2, color }) {
  return (
    <div className="spinner flex-cent">
      <svg width={width} viewBox="25 25 50 50">
        <circle
          fill="none"
          stroke={color ? color : '#305680'}
          strokeWidth={strokeWidth}
          cx="50"
          cy="50"
          r="20"
        />
      </svg>
    </div>
  );
}
